module.exports = __webpack_public_path__ + "c2fe74d3684ad703b2fe65275e945df5.gif";